import React from 'react';

import { Role } from '../../consts';
import NavigationItem from '../NavigationItem/NavigationItem';

interface Props {
    role: Role;
}

export default function AccountMenu({ role }: Props) {
    return (
        <div className="menu menu--constrained">
            <div className="menu__inner">
                <ul className="menu__item menu__item--action-list">
                    <NavigationItem
                        label={__('Account settings')}
                        icon="settings-1"
                        url="/account/personal-information"
                    />
                    <NavigationItem label={__('Profile')} icon="profile-2" url="/user/profile" />
                    {role === 'contest-holder' && (
                        <React.Fragment>
                            <NavigationItem
                                label={__('Transactions')}
                                icon="calculator-1"
                                url="/accounts/payments"
                            />
                            <NavigationItem
                                label={__('Credits')}
                                icon="server-1"
                                url="/accounts/credits"
                            />
                        </React.Fragment>
                    )}
                    {role === 'designer' && (
                        <React.Fragment>
                            <NavigationItem
                                label={__('Earnings')}
                                icon="server-1"
                                url="/accounts/earnings"
                            />
                            <NavigationItem
                                label={__('NDAs')}
                                icon="agreement-1"
                                url="/user/ndas"
                            />
                            <NavigationItem
                                label={__('Getting started')}
                                url="/account/getting-started"
                            />
                        </React.Fragment>
                    )}
                </ul>
                <ul className="menu__item menu__item--action-list menu__item--separated">
                    <NavigationItem
                        label={__('Log out')}
                        icon="logout-1"
                        url="/logout"
                        linkAdditionalClasses={['SMOKETEST_logout_link']}
                    />
                </ul>
            </div>
        </div>
    );
}
